import { map } from "rxjs/operators";
import { GET, POST, PUT } from "../../../../module/services/fetch";
import {
  IApplicationConfigurationTemporaryAbilitationsMgmt,
  ITemporaryEntitlementConfigurationMgmtBody,
} from "./constants";

export const fetchApplicationsListTemporaryAbilitationsMgmtRequest = (
  payload: any
) => {
  const { body, sortBy } = payload;
  return POST(
    `admin/applications/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${
            sortBy[0].id === "application"
              ? "name"
              : sortBy[0].id === "applicationDescription"
              ? "description"
              : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? "desc" : "asc"}`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchTemporaryAbilitationsListRequest = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `entitlements/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchTemporaryEntitlementsListRequestAbilitationMgmt = (
  payload: any
) => {
  const { body, sortBy } = payload;
  return POST(
    `temporary/admin/entitlement/paginated${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchGetConfigurationApplicationTemporaryAbilitationsMgmt =
  (payload: { applicationId: string; identitySystemId: string }) => {
    const { applicationId, identitySystemId } = payload;
    return GET(
      `temporary/admin/application/${applicationId}/configuration?identitySystemId=${identitySystemId}`
    ).pipe(map((response: any) => response));
  };

export const createConfigurationApplicationTemporaryAbilitationsManagement = (
  payload: IApplicationConfigurationTemporaryAbilitationsMgmt
) => {
  return POST(`temporary/admin/application/configuration`, payload).pipe(
    map((response: any) => response)
  );
};

export const updateConfigurationApplicationTemporaryAbilitationsManagement =
  (payload: {
    body: IApplicationConfigurationTemporaryAbilitationsMgmt;
    applicationId: string;
    identitySystemId: string;
  }) => {
    const { body, applicationId, identitySystemId } = payload;
    return PUT(
      `temporary/admin/application/${applicationId}/configuration?identitySystemId=${identitySystemId}`,
      body
    ).pipe(map((response: any) => response));
  };

export const fetchGetConfigurationsTemporaryAbilitationMgmt = (payload: {
  entitlementId: string;
  identitySystemId: string;
}) => {
  const { entitlementId, identitySystemId } = payload;
  return GET(
    `temporary/admin/entitlement/${entitlementId}/configuration?identitySystemId=${identitySystemId}`
  ).pipe(map((response: any) => response));
};

export const createConfigurationTemporaryAbilitation = (
  body: ITemporaryEntitlementConfigurationMgmtBody
) => {
  return POST(`temporary/admin/entitlement/configuration`, body).pipe(
    map((response: any) => response)
  );
};

export const updateConfigurationTemporaryAbilitation = (
  body: ITemporaryEntitlementConfigurationMgmtBody
) => {
  return PUT(`temporary/admin/entitlement/configuration`, body).pipe(
    map((response: any) => response)
  );
};

export const deleteConfigurationTemporaryAbilitationConsoleAdmin = (
  body: any
) => {
  return POST(`temporary/admin/entitlement/configuration/delete`, body).pipe(
    map((response: any) => response)
  );
};

export const manageTemporaryAbilitationsInSelectedApplication = (body: any) => {
  return POST(`temporary/admin/entitlement`, body).pipe(
    map((response: any) => response)
  );
};

export const fetchGetRolesTemporaryAbilitationConfiguration = () =>
  GET(`authentication/admin/view-roles`).pipe(map((response: any) => response));

export const createRoleTemporaryAbilitationConfigurationMgmt = (body: any) =>
  POST(`authentication/admin/static-roles`, body).pipe(
    map((response: any) => response)
  );

export const fetchTemporaryEntitlementsAlreadySetOnSelectedAbilitation = () =>
  POST(`temporary/admin/entitlement/paginated`, {
    pageNumber: 1,
    pageSize: 999999,
  }).pipe(map((response: any) => response));

export const fetchGetFieldsFromSelectedTemporaryAbilitation = (payload: {
  entitlementId: string;
  identitySystemId: string;
}) => {
  const { entitlementId, identitySystemId } = payload;
  return GET(
    `temporary/admin/entitlement/${entitlementId}/fields?identitySystemId=${identitySystemId}`
  ).pipe(map((response: any) => response));
};

export const updateFieldsFromSelectedTemporaryAbilitation = (payload: {
  entitlementId: string;
  identitySystemId: string;
  body: string[];
}) => {
  const { entitlementId, identitySystemId, body } = payload;
  return PUT(
    `temporary/admin/entitlement/${entitlementId}/fields?identitySystemId=${identitySystemId}`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchSystemUsersTemporaryAbilitation = () => {
  //w1 - project metro
  return POST("admin/user/find", { userType: "System" }).pipe(
    map((response: any) => response)
  );
};

export const fetchGlobalCatalogService = (obj: {}) =>
  POST("entitlements", obj).pipe(map((response: any) => response));

export const fetchEmergencyRequiredService = (configId: string) =>
  GET(`temporary/admin/emeTempEnt/${configId}`).pipe(
    map((response: any) => response)
  );

export const updateEmergencyConfigurationService = (body: {
  tempEntitlementId: string;
  entToadd: string[];
  entToremove: string[];
}) =>
  POST(`temporary/admin/emeTempEnt/update`, body).pipe(
    map((response: any) => response)
  );
